/* Bag and Card — custom replacement for the Wrapin Gift Wrap app (2026-08-02).
   Loaded site-wide from sections/footer.liquid.

   Three jobs:
   1. Product pages: when the "Bag and Card my disc" checkbox (rendered by
      snippets/bag-and-card.liquid) is checked and the product form is
      submitted, add one 'gift-wrap' ("Bag and Card") item to the cart with a
      'Product Name' property tying it to the disc.
   2. Reconcile: ONE rule — never more Bag and Card units in the cart than
      disc units (SKUs D#### / OS#### / ud## / PRE-####). Runs on page load and after any
      cart mutation (fetch and XHR are both watched). Removal order: lines
      with no Product Name property first (orphans), then lines whose Product
      Name matches nothing in the cart, then extras.
   3. Checkout guard: reconcile once more right before checkout, without ever
      blocking checkout for more than 1.5s.

   The old Wrapin app + footer jQuery cleanup missed property-less orphans and
   never counted per-disc — the exact bugs behind the 26 over-charged orders
   found in the 2026-08-01 sweep. Server-side backstop still exists in the
   veeqo-fbm-orders edge function. */
(function () {
  'use strict';
  // Two Bag and Card products: 'gift-wrap' ($1, opt-in on normal discs) and
  // 'bag-and-card-preorder' ($0, always included on pre-orders, added 2026-10-06).
  // Both must count as B&C for the one-per-disc rule.
  var BC_HANDLES = ['gift-wrap', 'bag-and-card-preorder'];
  function isBC(it) { return BC_HANDLES.indexOf(it.handle) !== -1; }
  // PRE-#### is a pre-ordered disc and counts as a disc. Without it reconcile saw
  // zero discs on a pre-order cart and deleted the Bag and Card again straight away.
  var DISC_SKU_RE = /^(D\d+|OS\d+|ud\d+|PRE-\d+)$/i;
  var rawFetch = window.fetch.bind(window);
  var reconciling = false;

  function getCart() {
    return rawFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function reconcile() {
    if (reconciling) return Promise.resolve();
    reconciling = true;
    var finish = function (v) { reconciling = false; return v; };
    return getCart().then(function (cart) {
      var discQty = 0, discTitles = {}, bcLines = [];
      (cart.items || []).forEach(function (it) {
        if (isBC(it)) { bcLines.push(it); return; }
        if (DISC_SKU_RE.test(it.sku || '')) {
          discQty += it.quantity;
          discTitles[it.product_title] = true;
        }
      });
      var bcTotal = bcLines.reduce(function (s, it) { return s + it.quantity; }, 0);
      var excess = bcTotal - discQty;
      if (excess <= 0) return null;
      var score = function (it) {
        var p = it.properties && it.properties['Product Name'];
        if (!p) return 0;          // orphan: no association at all
        if (!discTitles[p]) return 1; // points at a disc no longer in the cart
        return 2;                  // associated, only removed if still over count
      };
      bcLines.sort(function (a, b) { return score(a) - score(b); });
      var updates = {};
      for (var i = 0; i < bcLines.length && excess > 0; i++) {
        var take = Math.min(excess, bcLines[i].quantity);
        updates[bcLines[i].key] = bcLines[i].quantity - take;
        excess -= take;
      }
      return rawFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates }),
      }).then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
      });
    }).then(finish, finish);
  }

  // Product page: add Bag and Card after the theme's own AJAX add-to-cart.
  function hookProductPage() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      var wrap = document.querySelector('.bag-and-card');
      if (!wrap) return;
      // data-bc-auto (pre-order) has no checkbox and is always added; otherwise
      // the checkbox decides.
      var auto = wrap.getAttribute('data-bc-auto') === '1';
      var box = wrap.querySelector('.bag-and-card__checkbox');
      if (!auto && (!box || !box.checked)) return;
      var variantId = Number(wrap.getAttribute('data-bc-variant'));
      var title = wrap.getAttribute('data-bc-title');
      if (!variantId) return;
      setTimeout(function () {
        rawFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, properties: { 'Product Name': title } }),
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:build'));
          setTimeout(reconcile, 400);
        }).catch(function () {});
      }, 700);
    }, true);
  }

  // Reconcile right before checkout; never hold checkout longer than 1.5s.
  function hookCheckout() {
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest &&
        e.target.closest('[name="checkout"], a[href$="/checkout"], .cart__checkout');
      if (!el || el.getAttribute('data-bc-ok')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var done = false;
      var go = function () {
        if (done) return;
        done = true;
        el.setAttribute('data-bc-ok', '1');
        el.click();
        setTimeout(function () { el.removeAttribute('data-bc-ok'); }, 2000);
      };
      reconcile().then(go, go);
      setTimeout(go, 1500);
    }, true);
  }

  // Watch every cart mutation the theme makes (drawer qty changes, removals).
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = rawFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(reconcile, 500); }, function () {});
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      this.addEventListener('load', function () { setTimeout(reconcile, 500); });
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  function init() {
    hookProductPage();
    hookCheckout();
    setTimeout(reconcile, 1200);
  }
})();
